import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { notificar } from '../utils/notify';

// BPO RH — Agente de Currículos (só adm). Vagas soltas; subir o currículo guarda e
// lê o texto (sem CPF); a nota contra a vaga sai SÓ quando o adm seleciona e clica
// "Analisar selecionados". Aba "Perguntar": chat sobre os currículos da vaga (RAG).
// Vaga fechada há 180 dias tem os currículos apagados (LGPD).
const API = process.env.REACT_APP_API_BASE;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });
const NAVY = '#00205b';
const CIANO_ESCURO = '#008fa1';
const DOURADO = '#f1be48';
// lotes iguais aos limites do backend (Cloud Run corta requisição > 32 MiB)
const LOTE = 3;
const LOTE_ANALISE = 5;
const MAX_MB = 10;
const EXTS = ['.pdf', '.docx', '.png', '.jpg', '.jpeg', '.webp'];
const txt = (x) => (x == null ? '' : typeof x === 'string' ? x : JSON.stringify(x));
const SITUACOES = [
  { valor: 'novo', rotulo: 'Novo', cor: '#6c757d' },
  { valor: 'entrevista', rotulo: 'Entrevista', cor: '#0d6efd' },
  { valor: 'aprovado', rotulo: 'Aprovado', cor: '#198754' },
  { valor: 'descartado', rotulo: 'Descartado', cor: '#a11d2b' },
];

const comNegrito = (txt) => txt.split(/\*\*(.*?)\*\*/g).map((p, j) =>
  (j % 2 === 1 ? <strong key={j} style={{ color: NAVY }}>{p}</strong> : p));
const renderMarkdown = (texto) => String(texto || '').split('\n').map((linha, i) => {
  if (/^\s*[-•*]\s/.test(linha)) {
    return (<div key={i} style={{ display: 'flex', gap: 8, marginBottom: 3 }}>
      <span style={{ color: CIANO_ESCURO }}>•</span><span>{comNegrito(linha.replace(/^\s*[-•*]\s*/, ''))}</span></div>);
  }
  if (!linha.trim()) return <div key={i} style={{ height: 6 }} />;
  return <div key={i} style={{ marginBottom: 2 }}>{comNegrito(linha)}</div>;
});

const corNota = (n) => (n == null ? '#6c757d' : n >= 7 ? '#198754' : n >= 5 ? '#b58100' : '#a11d2b');

const BpoRhCurriculos = () => {
  const [vagas, setVagas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [vagaId, setVagaId] = useState(null);
  const [detalhe, setDetalhe] = useState(null);       // {vaga, curriculos}
  const [aba, setAba] = useState('curriculos');
  const [form, setForm] = useState(null);             // nova/editar vaga {id?, titulo, descricao, requisitos}
  const [selecionados, setSelecionados] = useState([]);
  const [enviando, setEnviando] = useState(null);     // texto do progresso do upload
  const [analisando, setAnalisando] = useState(false);
  const [aberto, setAberto] = useState(null);         // currículo no detalhe
  const [conversa, setConversa] = useState([]);
  const [pergunta, setPergunta] = useState('');
  const [perguntando, setPerguntando] = useState(false);
  const [aviso, setAviso] = useState(null);           // {texto, acao} — confirmação sem window.confirm
  const [arrastandoSobre, setArrastandoSobre] = useState(false);  // arquivo sobre a área de soltar
  const inputArq = useRef(null);
  const fimChat = useRef(null);

  const carregarVagas = useCallback(() => {
    setCarregando(true);
    axios.get(`${API}/api/bporh/curriculos/vagas/`, { params: { _: Date.now() }, headers: headers() })
      .then((r) => {
        setVagas(r.data.vagas || []);
        if (r.data.expurgados) notificar(`🗑️ ${r.data.expurgados} currículo(s) de vagas fechadas há mais de 180 dias foram apagados (LGPD)`);
      })
      .catch((e) => notificar(e.response?.data?.mensagem || 'Não foi possível carregar as vagas'))
      .finally(() => setCarregando(false));
  }, []);
  useEffect(() => { carregarVagas(); }, [carregarVagas]);

  const carregarVaga = useCallback((id) => {
    if (!id) return;
    axios.get(`${API}/api/bporh/curriculos/vagas/${id}/curriculos/`, { params: { _: Date.now() }, headers: headers() })
      .then((r) => setDetalhe(r.data))
      .catch((e) => notificar(e.response?.data?.mensagem || 'Não foi possível abrir a vaga'));
  }, []);
  useEffect(() => {
    setDetalhe(null); setSelecionados([]); setConversa([]); setAberto(null); setAba('curriculos');
    carregarVaga(vagaId);
  }, [vagaId, carregarVaga]);
  useEffect(() => { fimChat.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, [conversa, perguntando]);

  const salvarVaga = () => {
    const req = form.id
      ? axios.put(`${API}/api/bporh/curriculos/vagas/${form.id}/`, form, { headers: headers() })
      : axios.post(`${API}/api/bporh/curriculos/vagas/`, form, { headers: headers() });
    req.then((r) => {
      notificar(`✅ ${r.data.mensagem}`);
      setForm(null);
      carregarVagas();
      if (r.data.vaga) { setVagaId(r.data.vaga.id); carregarVaga(r.data.vaga.id); }
    }).catch((e) => notificar(`❌ ${e.response?.data?.mensagem || 'Não foi possível salvar a vaga'}`));
  };

  const mudarSituacaoVaga = (situacao) => {
    axios.put(`${API}/api/bporh/curriculos/vagas/${vagaId}/`, { situacao }, { headers: headers() })
      .then((r) => { notificar(`✅ ${r.data.mensagem}`); carregarVagas(); carregarVaga(vagaId); })
      .catch((e) => notificar(`❌ ${e.response?.data?.mensagem || 'Não foi possível alterar'}`));
  };

  const excluirVaga = () => {
    axios.delete(`${API}/api/bporh/curriculos/vagas/${vagaId}/`, { headers: headers() })
      .then((r) => { notificar(`✅ ${r.data.mensagem}`); setVagaId(null); carregarVagas(); })
      .catch((e) => notificar(`❌ ${e.response?.data?.mensagem || 'Não foi possível excluir'}`));
  };

  // sobe em lotes de 10 (limite do backend), um lote por vez
  const subir = async (lista) => {
    const todos = Array.from(lista || []);
    // confere formato e tamanho antes de mandar: o lote não falha por um arquivo ruim
    const arquivos = todos.filter((a) => {
      const ext = (a.name.match(/\.[^.]+$/) || [''])[0].toLowerCase();
      if (!EXTS.includes(ext)) { notificar(`⚠️ ${a.name}: formato não aceito (PDF, DOCX ou imagem)`); return false; }
      if (a.size > MAX_MB * 1024 * 1024) { notificar(`⚠️ ${a.name}: acima de ${MAX_MB} MB`); return false; }
      return true;
    });
    if (!arquivos.length) return;
    let ok = 0;
    for (let i = 0; i < arquivos.length; i += LOTE) {
      const lote = arquivos.slice(i, i + LOTE);
      setEnviando(`Lendo ${Math.min(i + LOTE, arquivos.length)} de ${arquivos.length}…`);
      const fd = new FormData();
      lote.forEach((a) => fd.append('arquivos', a));
      try {
        // eslint-disable-next-line no-await-in-loop
        const r = await axios.post(`${API}/api/bporh/curriculos/vagas/${vagaId}/curriculos/`, fd, { headers: headers() });
        for (const x of r.data.resultados || []) { if (x.ok) ok += 1; else notificar(`⚠️ ${x.arquivo}: ${x.mensagem}`); }
      } catch (e) {
        notificar(`❌ ${e.response?.data?.mensagem || 'Falha no envio'}`);
      }
    }
    setEnviando(null);
    notificar(`✅ ${ok} de ${arquivos.length} currículo(s) lido(s)`);
    carregarVaga(vagaId); carregarVagas();
  };

  // aceiteOcr: o adm autoriza mandar o escaneado/imagem inteiro à IA (LGPD)
  const reler = (c, aceiteOcr = false) => {
    setEnviando(`Lendo ${c.arquivo_nome}…`);
    axios.post(`${API}/api/bporh/curriculos/vagas/${vagaId}/curriculos/`,
      { reler: c.id, ...(aceiteOcr ? { aceite_ocr: true } : {}) }, { headers: headers() })
      .then((r) => notificar(r.data.resultados?.[0]?.ok ? '✅ Lido' : `⚠️ ${r.data.resultados?.[0]?.mensagem || 'Não lido'}`))
      .catch((e) => notificar(`❌ ${e.response?.data?.mensagem || 'Não foi possível ler'}`))
      .finally(() => { setEnviando(null); carregarVaga(vagaId); });
  };

  const analisar = async () => {
    setAnalisando(true);
    let ok = 0;
    for (let i = 0; i < selecionados.length; i += LOTE_ANALISE) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const r = await axios.post(`${API}/api/bporh/curriculos/vagas/${vagaId}/analisar/`,
          { ids: selecionados.slice(i, i + LOTE_ANALISE) }, { headers: headers() });
        for (const x of r.data.resultados || []) { if (x.ok) ok += 1; else notificar(`⚠️ ${x.nome}: ${x.mensagem}`); }
      } catch (e) {
        notificar(`❌ ${e.response?.data?.mensagem || 'Falha na análise'}`);
      }
    }
    setAnalisando(false);
    notificar(`✅ ${ok} currículo(s) analisado(s)`);
    setSelecionados([]);
    carregarVaga(vagaId); carregarVagas();
  };

  const mudarSituacao = (c, situacao) => {
    axios.put(`${API}/api/bporh/curriculos/${c.id}/`, { situacao }, { headers: headers() })
      .then(() => setDetalhe((d) => ({ ...d, curriculos: d.curriculos.map((x) => (x.id === c.id ? { ...x, situacao } : x)) })))
      .catch((e) => notificar(`❌ ${e.response?.data?.mensagem || 'Não foi possível alterar'}`));
  };

  const abrirArquivo = (c) => {
    // a janela abre no clique (o bloqueador de pop-up barra window.open depois do await)
    const janela = window.open('', '_blank');
    axios.get(`${API}/api/bporh/curriculos/${c.id}/`, { headers: headers(), responseType: 'blob' })
      .then((r) => {
        const url = URL.createObjectURL(r.data);
        if (janela) janela.location.href = url; else window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      })
      .catch(() => { if (janela) janela.close(); notificar('Não foi possível abrir o arquivo'); });
  };

  const excluirCurriculo = (c) => {
    axios.delete(`${API}/api/bporh/curriculos/${c.id}/`, { headers: headers() })
      .then((r) => { notificar(`✅ ${r.data.mensagem}`); setAberto(null); carregarVaga(vagaId); carregarVagas(); })
      .catch((e) => notificar(`❌ ${e.response?.data?.mensagem || 'Não foi possível excluir'}`));
  };

  const perguntar = (texto) => {
    const q = String(texto || '').trim();
    if (!q || perguntando) return;
    const historico = conversa.filter((m) => m.role === 'agente' && m.pergunta)
      .map((m) => ({ pergunta: m.pergunta, resposta: m.texto })).slice(-6);
    setConversa((c) => [...c, { role: 'user', texto: q }]);
    setPergunta('');
    setPerguntando(true);
    axios.post(`${API}/api/bporh/curriculos/vagas/${vagaId}/perguntar/`, { pergunta: q, historico }, { headers: headers() })
      .then((r) => setConversa((c) => [...c, { role: 'agente', pergunta: q, texto: r.data.texto, citados: r.data.citados }]))
      .catch((e) => setConversa((c) => [...c, { role: 'agente', erro: true, texto: e.response?.data?.mensagem || 'Não foi possível responder' }]))
      .finally(() => setPerguntando(false));
  };

  const ocupado = !!enviando || analisando || perguntando;
  const vaga = detalhe?.vaga;
  const curriculos = detalhe?.curriculos || [];
  const lidos = curriculos.filter((c) => c.lido);
  const todosSel = lidos.length > 0 && lidos.every((c) => selecionados.includes(c.id));

  // requisitos viram etiquetas (uma por linha ou separados por vírgula/ponto e vírgula)
  const requisitos = String(vaga?.requisitos || '').split(/[\n;,]+/).map((x) => x.trim()).filter(Boolean);

  return (
    <div className="cv-pagina">
      {/* ── cabeçalho ── */}
      <div className="cv-topo">
        <div className="cv-topo-icone"><i className="fas fa-file-lines" aria-hidden="true"></i></div>
        <div className="flex-grow-1">
          <h2 className="cv-titulo">Agente de Currículos</h2>
          <div className="cv-subtitulo">Cadastre a vaga, suba os currículos e escolha quais a IA deve avaliar. A nota é apoio: quem decide é você.</div>
        </div>
        <span className="cv-pill cv-pill-navy"><i className="fas fa-lock me-1" aria-hidden="true"></i>Só adm</span>
      </div>

      <div className="cv-grade">
        {/* ── vagas ── */}
        <aside className="cv-lateral">
          <div className="cv-lateral-topo">
            <span className="cv-secao">Vagas <span className="cv-contador">{vagas.length}</span></span>
            <button type="button" className="cv-btn cv-btn-primario" onClick={() => setForm({ titulo: '', descricao: '', requisitos: '' })}>
              <i className="fas fa-plus me-1" aria-hidden="true"></i>Nova vaga
            </button>
          </div>
          {carregando && <div className="text-center py-4 text-muted"><i className="fas fa-spinner fa-spin" aria-hidden="true"></i></div>}
          {!carregando && vagas.length === 0 && (
            <div className="cv-vazio-pequeno">
              <i className="fas fa-briefcase" aria-hidden="true"></i>
              <div>Nenhuma vaga ainda.</div>
              <div className="text-muted">Clique em "Nova vaga" para começar.</div>
            </div>
          )}
          <div className="cv-lista-vagas">
            {vagas.map((g) => (
              <button key={g.id} type="button" onClick={() => setVagaId(g.id)} disabled={ocupado && g.id !== vagaId}
                title={ocupado && g.id !== vagaId ? 'Aguarde a operação em andamento terminar' : undefined}
                className={`cv-vaga ${g.id === vagaId ? 'cv-vaga-ativa' : ''} ${g.situacao === 'fechada' ? 'cv-vaga-fechada' : ''}`}>
                <div className="d-flex justify-content-between align-items-start gap-2">
                  <span className="cv-vaga-titulo">{g.titulo}</span>
                  <span className={`cv-pill ${g.situacao === 'fechada' ? 'cv-pill-cinza' : 'cv-pill-verde'}`}>{g.situacao === 'fechada' ? 'Fechada' : 'Aberta'}</span>
                </div>
                <div className="cv-vaga-numeros">
                  <span><i className="fas fa-users me-1" aria-hidden="true"></i>{g.total} currículo(s)</span>
                  <span><i className="fas fa-star me-1" aria-hidden="true"></i>{g.analisados} analisado(s)</span>
                </div>
              </button>
            ))}
          </div>
        </aside>

        {/* ── vaga aberta ── */}
        <main className="cv-principal">
          {!vagaId && (
            <div className="cv-vazio">
              <div className="cv-vazio-icone"><i className="fas fa-briefcase" aria-hidden="true"></i></div>
              <h4>Escolha uma vaga</h4>
              <p>Selecione uma vaga na lista ao lado ou crie uma nova para subir os currículos.</p>
              <button type="button" className="cv-btn cv-btn-primario" onClick={() => setForm({ titulo: '', descricao: '', requisitos: '' })}>
                <i className="fas fa-plus me-1" aria-hidden="true"></i>Nova vaga
              </button>
            </div>
          )}
          {vagaId && !vaga && <div className="cv-vazio"><i className="fas fa-spinner fa-spin fa-2x text-muted" aria-hidden="true"></i></div>}
          {vaga && (
            <>
              <div className="cv-card">
                <div className="cv-vaga-cabeca">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <h3 className="cv-vaga-nome">{vaga.titulo}</h3>
                      <span className={`cv-pill ${vaga.situacao === 'fechada' ? 'cv-pill-cinza' : 'cv-pill-verde'}`}>{vaga.situacao === 'fechada' ? 'Fechada' : 'Aberta'}</span>
                    </div>
                    <div className="cv-meta">Criada em {vaga.criado_em}{vaga.criado_por ? ` por ${vaga.criado_por}` : ''} · {vaga.total} currículo(s) · {vaga.analisados} analisado(s)</div>
                  </div>
                  <div className="d-flex gap-2 flex-wrap">
                    <button type="button" className="cv-btn cv-btn-claro" onClick={() => setForm({ id: vaga.id, titulo: vaga.titulo, descricao: vaga.descricao || '', requisitos: vaga.requisitos || '' })}>
                      <i className="fas fa-pen me-1" aria-hidden="true"></i>Editar
                    </button>
                    {vaga.situacao === 'aberta'
                      ? <button type="button" className="cv-btn cv-btn-claro" onClick={() => setAviso({ texto: 'Fechar a vaga? Os currículos serão apagados automaticamente em 180 dias (LGPD).', acao: () => mudarSituacaoVaga('fechada') })}>
                        <i className="fas fa-lock me-1" aria-hidden="true"></i>Fechar vaga</button>
                      : <button type="button" className="cv-btn cv-btn-claro" onClick={() => mudarSituacaoVaga('aberta')}>
                        <i className="fas fa-lock-open me-1" aria-hidden="true"></i>Reabrir</button>}
                    {vaga.total === 0 && (
                      <button type="button" className="cv-btn cv-btn-perigo" onClick={() => setAviso({ texto: 'Excluir esta vaga?', acao: excluirVaga })}>
                        <i className="fas fa-trash me-1" aria-hidden="true"></i>Excluir</button>
                    )}
                  </div>
                </div>
                {vaga.situacao === 'fechada' && (
                  <div className="cv-alerta"><i className="fas fa-clock me-2" aria-hidden="true"></i>Vaga fechada em {vaga.fechada_em}. Os currículos serão apagados em <b>{vaga.expurgo_em}</b> (LGPD).</div>
                )}
                <div className="cv-info">
                  <div className="cv-info-bloco">
                    <div className="cv-rotulo"><i className="fas fa-align-left me-1" aria-hidden="true"></i>Descrição</div>
                    <div className="cv-info-texto">{vaga.descricao || <span className="text-muted">Sem descrição.</span>}</div>
                  </div>
                  <div className="cv-info-bloco">
                    <div className="cv-rotulo"><i className="fas fa-list-check me-1" aria-hidden="true"></i>Requisitos</div>
                    {requisitos.length
                      ? <div className="d-flex flex-wrap gap-2">{requisitos.map((r) => <span key={r} className="cv-tag">{r}</span>)}</div>
                      : <span className="text-muted">Sem requisitos: a nota fica menos precisa. Clique em "Editar".</span>}
                  </div>
                </div>
              </div>

              <div className="cv-abas">
                {[['curriculos', 'fa-users', `Currículos (${curriculos.length})`], ['perguntar', 'fa-comments', 'Perguntar à IA']].map(([k, ic, rot]) => (
                  <button key={k} type="button" className={`cv-aba ${aba === k ? 'cv-aba-ativa' : ''}`} onClick={() => setAba(k)}>
                    <i className={`fas ${ic} me-2`} aria-hidden="true"></i>{rot}
                  </button>
                ))}
              </div>

              {aba === 'curriculos' && (
                <div className="cv-card">
                  <input ref={inputArq} type="file" multiple hidden accept=".pdf,.docx,.png,.jpg,.jpeg,.webp"
                    onChange={(e) => { subir(e.target.files); e.target.value = ''; }} />
                  {vaga.situacao === 'aberta' && (
                    <div className={`cv-drop ${arrastandoSobre ? 'cv-drop-sobre' : ''} ${enviando ? 'cv-drop-ocupado' : ''}`}
                      role="button" tabIndex={0}
                      onClick={() => !enviando && inputArq.current?.click()}
                      onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && !enviando) inputArq.current?.click(); }}
                      onDragOver={(e) => { e.preventDefault(); setArrastandoSobre(true); }}
                      onDragLeave={() => setArrastandoSobre(false)}
                      onDrop={(e) => { e.preventDefault(); setArrastandoSobre(false); if (!enviando) subir(e.dataTransfer.files); }}>
                      {enviando ? (
                        <><span className="spinner-border spinner-border-sm me-2" style={{ color: CIANO_ESCURO }}></span><b>{enviando}</b></>
                      ) : (
                        <>
                          <div className="cv-drop-icone"><i className="fas fa-cloud-arrow-up" aria-hidden="true"></i></div>
                          <div><b>Arraste os currículos aqui</b> ou clique para escolher</div>
                          <div className="cv-drop-dica">PDF, DOCX ou imagem · até 10 MB cada · vários de uma vez</div>
                        </>
                      )}
                    </div>
                  )}
                  <div className="cv-lgpd">
                    <i className="fas fa-shield-halved me-2" aria-hidden="true"></i>
                    O texto vai para a IA do Google sem o CPF. Imagem ou PDF escaneado fica "não lido" até você clicar em "Ler pela IA": aí o arquivo inteiro vai para a leitura. Prefira currículos sem foto, documentos ou dados de saúde.
                  </div>

                  {curriculos.length > 0 && (
                    <div className="cv-barra">
                      <label className="d-flex align-items-center gap-2 m-0">
                        <input type="checkbox" className="form-check-input m-0" checked={todosSel} disabled={!lidos.length}
                          onChange={() => setSelecionados(todosSel ? [] : lidos.map((c) => c.id))} />
                        <span>Selecionar todos</span>
                      </label>
                      <span className="text-muted">{selecionados.length} selecionado(s)</span>
                      <button type="button" className="cv-btn cv-btn-primario ms-auto" disabled={!selecionados.length || analisando} onClick={analisar}>
                        {analisando ? <><span className="spinner-border spinner-border-sm me-2"></span>Analisando…</>
                          : <><i className="fas fa-wand-magic-sparkles me-2" aria-hidden="true"></i>Analisar selecionados</>}
                      </button>
                    </div>
                  )}

                  {curriculos.length === 0 ? (
                    <div className="cv-vazio-pequeno mt-3">
                      <i className="fas fa-file-circle-plus" aria-hidden="true"></i>
                      <div>Nenhum currículo nesta vaga ainda.</div>
                    </div>
                  ) : (
                    <div className="cv-candidatos">
                      {curriculos.map((c) => {
                        const sit = SITUACOES.find((s) => s.valor === c.situacao) || SITUACOES[0];
                        return (
                          <div key={c.id} className={`cv-candidato ${selecionados.includes(c.id) ? 'cv-candidato-sel' : ''}`}>
                            <input type="checkbox" className="form-check-input m-0" disabled={!c.lido} aria-label={`Selecionar ${c.nome}`}
                              checked={selecionados.includes(c.id)}
                              onChange={() => setSelecionados((s) => (s.includes(c.id) ? s.filter((x) => x !== c.id) : [...s, c.id]))} />
                            <div className="cv-nota" style={{ background: c.nota != null ? corNota(c.nota) : '#eef0f6', color: c.nota != null ? '#fff' : '#8a90a6' }}
                              title={c.nota != null ? 'Nota contra a vaga' : 'Ainda não analisado'}>
                              {c.nota != null ? c.nota.toLocaleString('pt-BR', { minimumFractionDigits: 1 }) : '—'}
                            </div>
                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                              <button type="button" className="cv-candidato-nome" onClick={() => setAberto(c)}>{c.nome}</button>
                              <div className="cv-candidato-sub">{[c.cidade, c.email, c.telefone].filter(Boolean).join(' · ') || c.arquivo_nome}</div>
                              {c.lido ? (
                                <div className="d-flex flex-wrap gap-1 mt-1">
                                  {(c.extraido?.competencias || []).slice(0, 6).map((x, i) => <span key={i} className="cv-tag cv-tag-pequena">{txt(x)}</span>)}
                                </div>
                              ) : (
                                <div className="cv-erro">
                                  <i className="fas fa-triangle-exclamation me-1" aria-hidden="true"></i>Não lido{c.erro_leitura ? `: ${c.erro_leitura}` : ''} ·{' '}
                                  {(c.erro_leitura || '').startsWith('Imagem ou PDF escaneado') ? (
                                    <button type="button" className="cv-link" onClick={() => reler(c, true)}
                                      title="Autoriza mandar este arquivo inteiro à IA do Google para a leitura">Ler pela IA</button>
                                  ) : (
                                    <button type="button" className="cv-link" onClick={() => reler(c)}>Ler de novo</button>
                                  )}
                                </div>
                              )}
                            </div>
                            <select className="form-select form-select-sm cv-situacao" style={{ color: sit.cor, borderColor: sit.cor }}
                              value={c.situacao} onChange={(e) => mudarSituacao(c, e.target.value)} aria-label="Situação do candidato">
                              {SITUACOES.map((s) => <option key={s.valor} value={s.valor}>{s.rotulo}</option>)}
                            </select>
                            <div className="d-flex gap-1">
                              <button type="button" className="cv-icone-btn" title="Ver análise" onClick={() => setAberto(c)}><i className="fas fa-eye" aria-hidden="true"></i></button>
                              <button type="button" className="cv-icone-btn" title="Abrir arquivo" onClick={() => abrirArquivo(c)}><i className="fas fa-file-arrow-down" aria-hidden="true"></i></button>
                              <button type="button" className="cv-icone-btn cv-icone-perigo" title="Excluir currículo"
                                onClick={() => setAviso({ texto: `Excluir o currículo de ${c.nome}? O arquivo é apagado de vez.`, acao: () => excluirCurriculo(c) })}>
                                <i className="fas fa-trash" aria-hidden="true"></i></button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {aba === 'perguntar' && (
                <div className="cv-card cv-chat">
                  <div className="cv-chat-msgs">
                    {conversa.length === 0 && (
                      <div className="cv-vazio" style={{ padding: '1.5rem 1rem' }}>
                        <div className="cv-vazio-icone"><i className="fas fa-robot" aria-hidden="true"></i></div>
                        <h4>Pergunte sobre os candidatos</h4>
                        <p>A IA responde com base nos currículos desta vaga.</p>
                        <div className="cv-sugestoes">
                          {[['fa-trophy', 'Quem são os 3 melhores para a vaga?'], ['fa-list-check', 'Quem atende todos os requisitos?'],
                            ['fa-magnifying-glass', 'Quem tem experiência com inglês?'], ['fa-chart-simple', 'Quais lacunas são mais comuns?']].map(([ic, s]) => (
                            <button key={s} type="button" className="cv-sugestao" onClick={() => perguntar(s)}>
                              <span className="cv-sugestao-icone"><i className={`fas ${ic}`} aria-hidden="true"></i></span>{s}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    {conversa.map((m, i) => (
                      <div key={i} className={`cv-msg ${m.role === 'user' ? 'cv-msg-eu' : ''}`}>
                        <div className={`cv-bolha ${m.role === 'user' ? 'cv-bolha-eu' : m.erro ? 'cv-bolha-erro' : 'cv-bolha-ia'}`}>
                          {m.role === 'user' ? m.texto : renderMarkdown(m.texto)}
                          {m.citados?.length > 0 && <div className="cv-citados">Baseado em: {m.citados.join(', ')}</div>}
                        </div>
                      </div>
                    ))}
                    {perguntando && (
                      <div className="cv-msg"><div className="cv-bolha cv-bolha-ia"><span className="cv-digitando"><i></i><i></i><i></i></span> lendo os currículos…</div></div>
                    )}
                    <div ref={fimChat} />
                  </div>
                  <form className="cv-chat-caixa" onSubmit={(e) => { e.preventDefault(); perguntar(pergunta); }}>
                    <input value={pergunta} maxLength={1000} disabled={perguntando}
                      placeholder='Ex.: "quem tem experiência com eSocial?" ou "compare a Ana com o Bruno"'
                      aria-label="Pergunta sobre os currículos" onChange={(e) => setPergunta(e.target.value)} />
                    <button type="submit" className="cv-enviar" disabled={perguntando || !pergunta.trim()} aria-label="Enviar">
                      <i className={`fas ${perguntando ? 'fa-spinner fa-spin' : 'fa-arrow-up'}`} aria-hidden="true"></i>
                    </button>
                  </form>
                </div>
              )}
            </>
          )}
        </main>
      </div>

      {/* ── modal: nova / editar vaga ── */}
      {form && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) setForm(null); }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-white">
                <h5 className="modal-title" style={{ color: '#212529' }}>{form.id ? 'Editar vaga' : 'Nova vaga'}</h5>
                <button type="button" className="btn-close" onClick={() => setForm(null)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label fw-semibold">Título</label>
                <input className="form-control mb-3" value={form.titulo} maxLength={200} placeholder="ex.: Analista de Departamento Pessoal"
                  onChange={(e) => setForm({ ...form, titulo: e.target.value })} />
                <label className="form-label fw-semibold">Descrição</label>
                <textarea className="form-control mb-3" rows={4} value={form.descricao} placeholder="Atividades e contexto da vaga"
                  onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
                <label className="form-label fw-semibold">Requisitos <span className="text-muted fw-normal small">(um por linha)</span></label>
                <textarea className="form-control" rows={5} value={form.requisitos} placeholder={'Experiência com folha de pagamento\neSocial\nInglês intermediário'}
                  onChange={(e) => setForm({ ...form, requisitos: e.target.value })} />
                <div className="form-text">É o que a IA confere em cada currículo. Separe obrigatórios de diferenciais para notas melhores.</div>
              </div>
              <div className="modal-footer bg-white">
                <button type="button" className="btn btn-secondary" onClick={() => setForm(null)}>Cancelar</button>
                <button type="button" className="btn text-white" style={{ background: NAVY }} disabled={!form.titulo.trim()} onClick={salvarVaga}>Salvar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── modal: detalhe do currículo ── */}
      {aberto && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) setAberto(null); }}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-white">
                <div className="d-flex align-items-center gap-3">
                  <div className="cv-nota cv-nota-grande" style={{ background: aberto.nota != null ? corNota(aberto.nota) : '#eef0f6', color: aberto.nota != null ? '#fff' : '#8a90a6' }}>
                    {aberto.nota != null ? aberto.nota.toLocaleString('pt-BR', { minimumFractionDigits: 1 }) : '—'}
                  </div>
                  <div>
                    <h5 className="modal-title" style={{ color: '#212529' }}>{aberto.nome}</h5>
                    <div className="small" style={{ color: '#6c757d' }}>{[aberto.email, aberto.telefone, aberto.cidade].filter(Boolean).join(' · ')}</div>
                  </div>
                </div>
                <button type="button" className="btn-close" onClick={() => setAberto(null)}></button>
              </div>
              <div className="modal-body">
                {aberto.nota != null
                  ? aberto.analise?.justificativa && <div className="cv-justificativa">{aberto.analise.justificativa}</div>
                  : <div className="cv-alerta mb-3">Ainda não analisado contra a vaga: selecione e clique em "Analisar selecionados".</div>}
                {aberto.extraido?.resumo && <p className="mb-3">{txt(aberto.extraido.resumo)}</p>}
                <div className="row g-3">
                  {[['Pontos fortes', aberto.analise?.pontos_fortes, '#198754', 'fa-circle-check'], ['Lacunas', aberto.analise?.lacunas, '#a11d2b', 'fa-circle-minus'],
                    ['Perguntas para a entrevista', aberto.analise?.perguntas_entrevista, NAVY, 'fa-comments']].filter(([, l]) => l?.length).map(([t, l, cor, ic]) => (
                    <div key={t} className={t.startsWith('Perguntas') ? 'col-12' : 'col-md-6'}>
                      <div className="cv-detalhe-bloco" style={{ borderLeftColor: cor }}>
                        <div className="fw-semibold mb-2" style={{ color: cor }}><i className={`fas ${ic} me-2`} aria-hidden="true"></i>{t}</div>
                        <ul className="ps-3 mb-0">{l.map((x, i) => <li key={i} className="mb-1">{txt(x)}</li>)}</ul>
                      </div>
                    </div>
                  ))}
                  <div className="col-12">
                    <div className="cv-rotulo">Competências</div>
                    <div className="d-flex flex-wrap gap-1">{(aberto.extraido?.competencias || []).map((x, i) => <span key={i} className="cv-tag cv-tag-pequena">{txt(x)}</span>)}</div>
                  </div>
                  <div className="col-md-6">
                    <div className="cv-rotulo">Formação</div>
                    <ul className="ps-3 mb-0 small">{(aberto.extraido?.formacao || []).map((x, i) => <li key={i}>{txt(x)}</li>)}</ul>
                  </div>
                  <div className="col-md-6">
                    <div className="cv-rotulo">Idiomas</div>
                    <div className="small">{(aberto.extraido?.idiomas || []).map(txt).join(', ') || '—'}</div>
                  </div>
                  <div className="col-12">
                    <div className="cv-rotulo">Experiências</div>
                    {(aberto.extraido?.experiencias || []).map((x, i) => (
                      <div key={i} className="cv-exp">
                        <div><b>{txt(x?.cargo)}</b>{x?.empresa ? ` — ${txt(x.empresa)}` : ''}</div>
                        {x?.periodo && <div className="text-muted small">{txt(x.periodo)}</div>}
                        {x?.resumo && <div className="small mt-1">{txt(x.resumo)}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="modal-footer bg-white">
                <button type="button" className="btn btn-light border" onClick={() => abrirArquivo(aberto)}><i className="fas fa-file-arrow-down me-1" aria-hidden="true"></i>Abrir arquivo</button>
                <button type="button" className="btn btn-secondary" onClick={() => setAberto(null)}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── confirmação (sem window.confirm) ── */}
      {aviso && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">{aviso.texto}</div>
              <div className="modal-footer bg-white">
                <button type="button" className="btn btn-secondary" onClick={() => setAviso(null)}>Cancelar</button>
                <button type="button" className="btn btn-danger" onClick={() => { const a = aviso.acao; setAviso(null); a(); }}>Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .cv-pagina { padding: 1.5rem 1.75rem 2rem; background: #f4f6fb; min-height: 100vh; font-size: .95rem; color: #212529; }
        @media (max-width: 768px) { .cv-pagina { padding: 1rem .75rem; } }
        .cv-topo { display: flex; align-items: center; gap: 14px; background: #fff; border: 1px solid #e4e7f0; border-radius: 16px; padding: 1.1rem 1.4rem; margin-bottom: 1.25rem; box-shadow: 0 1px 4px rgba(0,0,0,.04); }
        .cv-topo-icone { width: 46px; height: 46px; border-radius: 12px; background: rgba(241,190,72,.15); color: ${DOURADO}; display: flex; align-items: center; justify-content: center; font-size: 1.3rem; flex-shrink: 0; }
        .cv-titulo { margin: 0; font-size: 1.4rem; font-weight: 800; color: #1a1d2e; letter-spacing: -.3px; position: relative; display: inline-block; }
        .cv-titulo::after { content: ''; display: block; width: 36px; height: 3px; background: #00b5cc; border-radius: 2px; margin-top: 4px; }
        .cv-subtitulo { color: #6b7289; font-size: .88rem; margin-top: 4px; }
        .cv-grade { display: grid; grid-template-columns: 320px 1fr; gap: 1.25rem; align-items: start; }
        @media (max-width: 991px) { .cv-grade { grid-template-columns: 1fr; } }
        .cv-lateral { background: #fff; border: 1px solid #e4e7f0; border-radius: 16px; padding: 1rem; box-shadow: 0 1px 4px rgba(0,0,0,.04); position: sticky; top: 1rem; }
        .cv-lateral-topo { display: flex; align-items: center; justify-content: space-between; margin-bottom: .85rem; }
        .cv-secao { font-weight: 700; color: #1a1d2e; font-size: 1rem; }
        .cv-contador { background: #eef0f6; color: #5a607a; border-radius: 20px; padding: 1px 8px; font-size: .75rem; margin-left: 4px; }
        .cv-lista-vagas { display: flex; flex-direction: column; gap: .6rem; max-height: 70vh; overflow-y: auto; }
        .cv-vaga { text-align: left; background: #fff; border: 1.5px solid #e4e7f0; border-radius: 12px; padding: .8rem .9rem; transition: border-color .15s, box-shadow .15s; width: 100%; }
        .cv-vaga:hover:not(:disabled) { border-color: #00b5cc; }
        .cv-vaga:disabled { opacity: .55; cursor: not-allowed; }
        .cv-vaga-ativa { border-color: #00b5cc; box-shadow: 0 0 0 3px rgba(0,181,204,.15); background: #f5fdfe; }
        .cv-vaga-fechada .cv-vaga-titulo { color: #6c757d; }
        .cv-vaga-titulo { font-weight: 600; color: #1a1d2e; line-height: 1.3; }
        .cv-vaga-numeros { display: flex; gap: 12px; color: #7a8199; font-size: .8rem; margin-top: 6px; }
        .cv-principal { min-width: 0; display: flex; flex-direction: column; gap: 1rem; }
        .cv-card { background: #fff; border: 1px solid #e4e7f0; border-radius: 16px; padding: 1.25rem 1.4rem; box-shadow: 0 1px 4px rgba(0,0,0,.04); }
        .cv-vaga-cabeca { display: flex; gap: 1rem; align-items: flex-start; flex-wrap: wrap; }
        .cv-vaga-nome { margin: 0; font-size: 1.3rem; font-weight: 800; color: #1a1d2e; }
        .cv-meta { color: #7a8199; font-size: .82rem; margin-top: 4px; }
        .cv-info { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-top: 1.1rem; }
        @media (max-width: 768px) { .cv-info { grid-template-columns: 1fr; } }
        .cv-info-bloco { background: #f7f8fc; border-radius: 12px; padding: .9rem 1rem; }
        .cv-info-texto { white-space: pre-wrap; line-height: 1.55; }
        .cv-rotulo { font-size: .75rem; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: #5a607a; margin-bottom: .45rem; }
        .cv-tag { background: rgba(0,181,204,.1); color: #006f7d; border: 1px solid rgba(0,181,204,.25); border-radius: 20px; padding: 3px 11px; font-size: .82rem; font-weight: 500; }
        .cv-tag-pequena { font-size: .72rem; padding: 1px 8px; }
        .cv-pill { border-radius: 20px; padding: 2px 10px; font-size: .72rem; font-weight: 700; white-space: nowrap; }
        .cv-pill-verde { background: #e6f7ef; color: #116b47; }
        .cv-pill-cinza { background: #eef0f6; color: #6c757d; }
        .cv-pill-navy { background: #00205b; color: #fff; }
        .cv-btn { border-radius: 10px; font-size: .86rem; font-weight: 600; padding: .45rem .9rem; border: 1px solid transparent; transition: all .15s; white-space: nowrap; }
        .cv-btn:disabled { opacity: .5; cursor: not-allowed; }
        .cv-btn-primario { background: linear-gradient(135deg, #00205b, #003580); color: #fff; box-shadow: 0 3px 10px rgba(0,32,91,.25); }
        .cv-btn-primario:hover:not(:disabled) { box-shadow: 0 4px 14px rgba(0,32,91,.35); }
        .cv-btn-claro { background: #fff; color: #3a3d52; border-color: #dfe3ee; }
        .cv-btn-claro:hover:not(:disabled) { background: #f5f6fa; }
        .cv-btn-perigo { background: #fff; color: #a11d2b; border-color: #f3c2c8; }
        .cv-btn-perigo:hover { background: #fdeef0; }
        .cv-alerta { background: #fff8e6; border: 1px solid #f3e1a9; color: #7a5d00; border-radius: 10px; padding: .6rem .9rem; font-size: .86rem; margin-top: 1rem; }
        .cv-abas { display: flex; gap: .5rem; background: #fff; border: 1px solid #e4e7f0; border-radius: 14px; padding: .35rem; width: fit-content; }
        .cv-aba { border: none; background: transparent; border-radius: 10px; padding: .5rem 1rem; font-weight: 600; color: #5a607a; font-size: .9rem; }
        .cv-aba-ativa { background: #00205b; color: #fff; }
        .cv-drop { border: 2px dashed #c9d3e6; border-radius: 14px; padding: 1.6rem 1rem; text-align: center; cursor: pointer; color: #3a3d52; background: #fafbfe; transition: all .15s; }
        .cv-drop:hover, .cv-drop:focus { border-color: #00b5cc; background: #f3fcfd; outline: none; }
        .cv-drop-sobre { border-color: #00b5cc; background: #e9f9fb; }
        .cv-drop-ocupado { cursor: progress; }
        .cv-drop-icone { font-size: 1.8rem; color: #00b5cc; margin-bottom: .35rem; }
        .cv-drop-dica { font-size: .8rem; color: #7a8199; margin-top: .25rem; }
        .cv-lgpd { display: flex; align-items: flex-start; font-size: .8rem; color: #5a607a; background: #f4f6fb; border-radius: 10px; padding: .6rem .8rem; margin-top: .75rem; line-height: 1.5; }
        .cv-lgpd i { color: #008fa1; margin-top: 2px; }
        .cv-barra { display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; margin: 1.1rem 0 .6rem; padding-bottom: .6rem; border-bottom: 1px solid #eef0f6; font-size: .88rem; }
        .cv-candidatos { display: flex; flex-direction: column; gap: .55rem; }
        .cv-candidato { display: flex; align-items: center; gap: .9rem; border: 1px solid #e9ecf3; border-radius: 12px; padding: .75rem .9rem; transition: border-color .15s, background .15s; }
        .cv-candidato:hover { border-color: #cfd8ea; background: #fbfcfe; }
        .cv-candidato-sel { border-color: #00b5cc; background: #f5fdfe; }
        @media (max-width: 768px) { .cv-candidato { flex-wrap: wrap; } }
        .cv-nota { width: 46px; height: 46px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 1rem; flex-shrink: 0; }
        .cv-nota-grande { width: 56px; height: 56px; font-size: 1.2rem; }
        .cv-candidato-nome { border: none; background: none; padding: 0; font-weight: 700; color: #1a1d2e; text-align: left; }
        .cv-candidato-nome:hover { color: #008fa1; text-decoration: underline; }
        .cv-candidato-sub { color: #7a8199; font-size: .8rem; }
        .cv-erro { color: #a11d2b; font-size: .8rem; margin-top: 4px; }
        .cv-link { border: none; background: none; padding: 0; color: #008fa1; font-weight: 600; font-size: .8rem; }
        .cv-situacao { width: 135px; font-weight: 600; flex-shrink: 0; }
        .cv-icone-btn { width: 34px; height: 34px; border-radius: 9px; border: 1px solid #e4e7f0; background: #fff; color: #5a607a; display: flex; align-items: center; justify-content: center; }
        .cv-icone-btn:hover { background: #f5f6fa; color: #00205b; }
        .cv-icone-perigo:hover { color: #a11d2b; background: #fdeef0; }
        .cv-vazio { text-align: center; padding: 3rem 1.5rem; background: #fff; border: 1px solid #e4e7f0; border-radius: 16px; }
        .cv-vazio h4 { font-weight: 800; color: #1a1d2e; margin: .75rem 0 .35rem; font-size: 1.2rem; }
        .cv-vazio p { color: #7a8199; margin-bottom: 1.1rem; }
        .cv-chat .cv-vazio { border: none; }
        .cv-vazio-icone { width: 64px; height: 64px; border-radius: 50%; background: rgba(0,181,204,.1); color: #008fa1; display: inline-flex; align-items: center; justify-content: center; font-size: 1.6rem; }
        .cv-vazio-pequeno { text-align: center; color: #6b7289; padding: 1.5rem .5rem; font-size: .88rem; }
        .cv-vazio-pequeno i { font-size: 1.6rem; color: #c3cad9; margin-bottom: .4rem; display: block; }
        .cv-chat { display: flex; flex-direction: column; padding: 0; overflow: hidden; }
        .cv-chat-msgs { max-height: 520px; min-height: 320px; overflow-y: auto; padding: 1.25rem; background: #f7f8fc; }
        .cv-sugestoes { display: grid; grid-template-columns: 1fr 1fr; gap: .6rem; max-width: 620px; margin: 0 auto; }
        @media (max-width: 640px) { .cv-sugestoes { grid-template-columns: 1fr; } }
        .cv-sugestao { display: flex; align-items: center; gap: .6rem; text-align: left; background: #fff; border: 1.5px solid #e4e7f0; border-radius: 12px; padding: .7rem .85rem; font-size: .88rem; color: #3a3d52; transition: all .15s; }
        .cv-sugestao:hover { border-color: #00b5cc; transform: translateY(-1px); box-shadow: 0 3px 10px rgba(0,181,204,.12); }
        .cv-sugestao-icone { width: 30px; height: 30px; border-radius: 8px; background: rgba(0,181,204,.1); color: #008fa1; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .cv-msg { display: flex; margin-bottom: .8rem; }
        .cv-msg-eu { justify-content: flex-end; }
        .cv-bolha { max-width: 82%; padding: .75rem 1rem; line-height: 1.6; overflow-wrap: anywhere; }
        .cv-bolha-eu { background: linear-gradient(135deg, #00205b, #003580); color: #fff; border-radius: 18px 18px 4px 18px; white-space: pre-wrap; }
        .cv-bolha-ia { background: #fff; border-radius: 18px 18px 18px 4px; box-shadow: 0 1px 6px rgba(0,0,0,.06); }
        .cv-bolha-erro { background: #fff3cd; color: #664d03; border-radius: 18px 18px 18px 4px; }
        .cv-citados { margin-top: .4rem; font-size: .72rem; color: #8a90a6; }
        .cv-chat-caixa { display: flex; gap: .6rem; padding: .85rem 1rem; border-top: 1px solid #eef0f6; background: #fff; }
        .cv-chat-caixa input { flex: 1; border: 1.5px solid #e4e7f0; border-radius: 12px; padding: .6rem .9rem; outline: none; }
        .cv-chat-caixa input:focus { border-color: #00b5cc; }
        .cv-enviar { width: 42px; height: 42px; border-radius: 50%; border: none; background: linear-gradient(135deg, #00205b, #003580); color: #fff; flex-shrink: 0; }
        .cv-enviar:disabled { background: #eef0f8; color: #b0b7cc; }
        .cv-digitando { display: inline-flex; gap: 3px; margin-right: 6px; }
        .cv-digitando i { width: 6px; height: 6px; border-radius: 50%; background: #00b5cc; display: block; animation: cvDig 1.2s ease-in-out infinite; }
        .cv-digitando i:nth-child(2) { animation-delay: .2s; }
        .cv-digitando i:nth-child(3) { animation-delay: .4s; }
        @keyframes cvDig { 0%, 60%, 100% { transform: translateY(0); opacity: .4; } 30% { transform: translateY(-5px); opacity: 1; } }
        .cv-justificativa { background: #f7f8fc; border-radius: 10px; padding: .75rem 1rem; margin-bottom: 1rem; color: #3a3d52; }
        .cv-detalhe-bloco { border-left: 4px solid; background: #fafbfe; border-radius: 0 10px 10px 0; padding: .75rem 1rem; height: 100%; }
        .cv-exp { border-left: 2px solid #e4e7f0; padding: .2rem 0 .5rem .8rem; margin-bottom: .4rem; }
      `}</style>
    </div>
  );
};

export default BpoRhCurriculos;
